import { Component } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';
import { Observable, map } from 'rxjs';

import { CultureService } from '../../../../services/culture.service';
import { fromServerIsoString } from '../../../../utils/interop';
import { SearchPageDiff } from '../../../redux/search-page.state';

@Component({
    selector: 'se-diff-header',
    templateUrl: './diff-header.component.html',
    styleUrls: ['./diff-header.component.scss'],
    standalone: false
})
export class DiffHeaderComponent implements IHeaderAngularComp {
    diff$: Observable<string>;

    constructor(private culture: CultureService) {}

    agInit(params: IHeaderParams) {
        const obs = params.context.diff$ as Observable<SearchPageDiff[]>;

        this.diff$ = obs.pipe(map((diffs) => diffs.map((d) => this.formatDiff(d)).join('\n')));
    }

    refresh(params: IHeaderParams): boolean {
        this.agInit(params);

        return true;
    }

    private formatDiff(diff: SearchPageDiff) {
        const date = diff.date
            ? fromServerIsoString(diff.date).format(this.culture.getShortDatePattern().toLocaleUpperCase())
            : undefined;

        return diff.info1 + (date ? ` - ${date}` : '') + (diff.info2 ? ` - ${diff.info2}` : '');
    }
}
